<template lang="pug">
  e-chart(
    :header="`${documentTitle}, ${measure}`"
    :options="chartDynamicOptions"
    :series="chartDynamicSeries"
    chartId="dynamic"
    ref="chart"
    :chartRedirectParams="chartRedirectParams"
      :chartLoading="chartLoading"
      :chartError="chartError"
  )
    template(slot="chartHeader")
      .default-select.part-3-from-4
        e-suggestion(
          tabView="tab1"
          :model="fields"
          name="dynamicTypeTmpName"
          realName="dynamicType"
          :options="chartDynamicTypeOptions"
          :useInnerSearch="true"
          :minSuggestLen="0"
        ).e-suggestion--wrap-items
      .default-select.part-1-from-4
        e-select(
        class="dropdown-btn"
        tabView="tab1"
        :model="fields"
        placeholder="Период"
        name="dynamicTypePeriod"
        :options="dynamicTypePeriodOptions"
        )
</template>

<script>
  import chartsMixin from '../mixins/charts-mixin.js'
  import {indicator} from '../../../api/api-endpoints'
  import yearHandler from '../../../utils/year'

  export default {
    mixins: [chartsMixin],
    data () {
      return {
        measure: '%'
      }
    },
    created () {
      this.pointStart = 0
      this.chartDynamicOptions = this.getCurrentChartOptions
      this.fetchIndicators()
    },
    watch: {
      'fields.dynamic.viewMode': {
        handler: function(v) {
          this.viewMode = v
          this.fetchData()
        }
      },
      'fields.dynamicType': 'fetchData',
      'fields.dynamicTypePeriod': 'onDynamicTypePeriod'
    },
    computed: {
      viewMode: {
        get: function () {
          return this.$store.getters.charts.dynamic.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {dynamic: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('dynamic')
      }
    },
    methods: {
      onDynamicTypePeriod () {
        const endpoint = this.buildEndpoint()
        let r = {
          data: this.$store.getters.readUrlEndpoint(endpoint) || {}
        }
        if (r) {
          this.chartDynamicSeries = this.transform(r)
          this.createAndSetCats(r, this.chartDynamicSeries)
        }
      },
      getYearPeriod () {
        return this.fields.dynamicTypePeriod ? {
          startYear: yearHandler.getCurrentYear(),
          endYear: yearHandler.getCurrentYear() + this.fields.dynamicTypePeriod - 1
        } : null
      },
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            type: 'cp',
            cp_id: this.fields.dynamicType,
            viewMode: this.viewMode
          }
        })
      },
      fetchIndicators () {
        this.loading = true
        return this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.objects({
            query: {
              'per-page': -1
            }
          }),
          params: {
            disableGlobalError: true
          }
        }).then(r => {
          if (r.data.data) {
            this.chartDynamicTypeOptions = r.data.data
            // set first option on init
            if (this.fields.dynamicType === null) {
              let defaultOption = this.chartDynamicTypeOptions[0]
              this.fields.dynamicType = defaultOption.id
              this.fields.dynamicTypeTmpName = defaultOption.name
              this.loading = false
            } else {
              this.fetchData()
            }
          } else {
            this.loading = false
          }
          return r
        }).catch(e => {
          this.loading = false
          this.chartError = e
          return e
        })
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartDynamicSeries = r.data.data ? this.transform(r.data.data) : []
          this.createAndSetCats()
        })
      },
      transform (response) {
        this.measure = response.measure || this.measure
        let years = this.getYearPeriod()

        this.pointStart = +response.start
        if (!this.pointStart || years && years.startYear) {
          this.pointStart = years.startYear
        }
        if(!response.series|| !response.series.length > 0){
          return []
        }
        // series have special fill colors options
        let series = response.series
        let newSeries = []
        let defaultSeries = this.getChartSeries('dynamic')
        for (let i = 0; i < series.length; i++) {
          newSeries[i] = {data: []}
          for (let j = 0; j < series[i].data.length; j++) {
            let year = this.pointStart + j
            let yearIsIncorrect = years && years.startYear && years.endYear && (year < years.startYear || year > years.endYear)
            if (yearIsIncorrect) {
              continue
            }
            newSeries[i].data.push(+series[i].data[j] || null)
          }
          newSeries[i] = Object.assign(defaultSeries[i], newSeries[i])
        }
        return newSeries
      },
      createAndSetCats () {
        let options = Object.assign({}, this.chartDynamicOptions)
        options.plotOptions.area.pointStart = this.pointStart || 2000
        this.chartDynamicOptions = options
        this.$refs.chart.drawChart()
      }
    }
  }
</script>
